import * as geoUtils from "@/utils/geoDistance";

export function appendFiles(data: FormData, files: File[]) {
  for (let index = 0; index < files.length; index++) {
    data.append(`anexo${index + 1}`, files[index]);
  }
}

export async function appendLocation(data: FormData, includeEmptyValues = false) {
  const coords: any = await geoUtils.GetLocation().catch(() => null);

  if (!coords && !includeEmptyValues) return;

  data.append("lat", coords?.latitude ?? "");
  data.append("lng", coords?.longitude ?? "");
}

export function buildEncryptedDocumentUrl(baseURL: string, { vinculo, protocolo }) {
  const key = `${vinculo};${protocolo}`;
  const chave = `${globalThis.window.$jse.encrypt(key)}`;
  const queryString = new URLSearchParams({
    vinculo,
    chave,
    tipo: ".pdf"
  }).toString();

  return `${baseURL}/ObterDocumento?${queryString}`;
}

export async function fetchEncryptedImage(baseURL: string, { vinculo, documento, original }) {
  const key = `${vinculo};${documento};${original ? "T" : "F"}`;
  const chave = `${globalThis.window.$jse.encrypt(key)}`;

  return await globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterImagem`,
      query: {
        vinculo,
        chave,
        original
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterImagem", error.message);
      throw new Error(error.message);
    });
}
